module.exports = __webpack_public_path__ + "static/img/mantou.b847f9de.png";